import { Component } from 'react';
import { connect } from 'react-redux';

import forEach from 'lodash/forEach';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import UploadFileFormComponent from '../../DocumentLibrary/components/UploadFileFormComponent';

import {
  preuploadDocumentForCommunity,
  setDocumentAsAttachmentCommunity,
} from '../../Community/actions';
import { preuploadDocument, setDocumentAsAttachment } from '../actions';

import { UPLOAD_FILE_FORM } from '../../DocumentLibrary/constants';
import {
  MESSAGES_SELECT_DOCUMENT,
  MESSAGES_UPLOAD_DOCUMENT,
} from '../constants';

import DocumentLibrary from '../../DocumentLibrary';

class AttachDocumentContainer extends Component {
  onSubmit = async (data) => {
    const { preuploadDocument } = this.props;
    if (!data.file) return false;
    const formData = new FormData();

    forEach(data.file, (file) => formData.append('document', file));

    const documentValidationResult = await preuploadDocument(formData);
    const documentId = get(documentValidationResult, 'data.document');
    const documentName = get(documentValidationResult, 'data.documentName');
    if (!documentId || !documentName) return false;

    return this.attachDocument(documentId, documentName);
  };

  attachDocument = async (documentId, documentName) => {
    const { checkNewAttachment, setDocumentAsAttachment, closeModal } =
      this.props;

    const documentPermissionResult = await checkNewAttachment(documentId);
    if (!documentPermissionResult) return false;

    setDocumentAsAttachment(documentId, documentName);
    return closeModal();
  };

  render() {
    const { type } = this.props;

    return (
      <section>
        {type === MESSAGES_UPLOAD_DOCUMENT && (
          <UploadFileFormComponent
            form={UPLOAD_FILE_FORM}
            onSubmit={this.onSubmit}
            submitText="Attach Document"
          />
        )}
        {type === MESSAGES_SELECT_DOCUMENT && (
          <DocumentLibrary attachDocument={this.attachDocument} />
        )}
      </section>
    );
  }
}

AttachDocumentContainer.propTypes = {
  type: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  preuploadDocument: PropTypes.func.isRequired,
  checkNewAttachment: PropTypes.func.isRequired,
  setDocumentAsAttachment: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { widgetType } = ownProps;
  const {
    documentId: attachmentDocumentId,
    documentName: attachmentDocumentName,
    text: newMessageText,
  } = widgetType === 'community'
    ? state?.community?.newMessage ?? {}
    : state?.messages?.newMessage ?? {};

  return { attachmentDocumentId, attachmentDocumentName, newMessageText };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { widgetType } = ownProps;
  return {
    preuploadDocument: (data) =>
      widgetType === 'community'
        ? preuploadDocumentForCommunity(dispatch, data)
        : preuploadDocument(dispatch, data),
    setDocumentAsAttachment: (documentId, documentName) =>
      widgetType === 'community'
        ? setDocumentAsAttachmentCommunity(dispatch, documentId, documentName)
        : setDocumentAsAttachment(dispatch, documentId, documentName),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AttachDocumentContainer);
